// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUi from 'element-ui'
import axios from 'axios'

Vue.use(ElementUi)

import '../css/index.css'
import 'common/stylus/index.styl'

Vue.config.productionTip = false

// 进入组件后定位到页面顶部
router.afterEach((route) => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js